export default {
  props: {
    menu: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeDropdown: null,
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    toggleDropdown(index) {
      if (this.activeDropdown === index) {
        this.activeDropdown = null
      } else {
        this.activeDropdown = index
      }
    },
    handleOutsideClick(event) {
      if (!event.target.closest('.desktop-nav__dropdown')) {
        this.activeDropdown = null
      }
    },
  },
}
